import { AccountInfo } from '@azure/msal-browser';

export const initialAuthState: AuthState = {
  account: null,
};

export interface AuthState {
  account: AccountInfo | null;
}
